/**
 * This file contains all american english translations (messages) used in the web app.
 * Must be a flat key-value object where keys are sorted in alphanumerical order.
 * We are using the ICU message syntax: https://formatjs.io/guides/message-syntax/
 * Format keys using upper snake case and name them by a hierarchy representing location inside the app
 * Example: 'BASIC_BUTTON_ADD_TEXT'
 */

export default {
  LANDING_PAGE_GENERAL_ERROR_TEXT: 'Could not find user, is the email and code correct?',
  LANDING_PAGE_END_DATE_LABEL: 'Last date for making changes is: ',
  LANDING_PAGE_EMAIL_INPUT_LABEL: 'Enter your email here',
  LANDING_PAGE_EMAIL_REQUIRED_TEXT: 'Email is required',
  LANDING_PAGE_EMAIL_VALID_TEXT: 'Not a vailid email',
  LANDING_PAGE_ACCESS_CODE_INPUT_LABEL: 'Enter your code here',
  LANDING_PAGE_ACCESS_CODE_REQUIRED_TEXT: 'Code is required',
  LANDING_PAGE_ACCESS_CODE_MIN_LENGTH_TEXT: 'Code need to be at least 2 characters',
  LANDING_PAGE_ACCESS_CODE_MAX_LENGTH_TEXT: 'Code can not be more then 5 characters',
  LANDING_PAGE_INPUT_SUBMIT_BUTTON: 'Next',
  LANDING_PAGE_ANY_QUESTION: 'Any questions? Please contact:',
  WELCOME_PAGE_TITLE: `Welcome {name}`,
  WELCOME_PAGE_ABORT_BUTTON: 'Cancel',
  WELCOME_PAGE_START_BUTTON: 'Begin',
  WELCOME_PAGE_CONTINUE_BUTTON: 'Continue',
  WELCOME_PAGE_APARTMENT_TYPE: 'Your apartment type:',
  WELCOME_PAGE_APARTMENT_NUMBER: 'Your apartment number:',
  WELCOME_PAGE_ANY_QUESTION: 'Any questions? Please contact:',
  TOP_NAVIGATION_BAR_GO_BACK: 'Intro',
  BOTTOM_ACTION_BAR_BUTTON_TEXT: 'Summary',
  SUMMARY_PAGE_TITLE: 'Summary',
  SUMMARY_PAGE_PRIMARY_ACTION_LABEL: 'Confirm',
  SUMMARY_PAGE_SECONDARY_ACTION_LABEL: 'Return',
  SUMMARY_PAGE_ABPROVE_TERMS_AND_CONDITIONS_TITLE: 'Terms & conditions',
  SUMMARY_PAGE_ABPROVE_TERMS_AND_CONDITIONS: 'I agree to the  <link>terms and conditions</link>',
  SUMMARY_PAGE_ABPROVE_TERMS_AND_CONDITIONS_BUTTON: 'Agree',
  SUMMARY_PAGE_TOTAL_LABEL: 'Total',
  SUMMARY_PAGE_SUBMIT_SELECTION_ERROR: 'An error occured while saving your choices',
  SUMMARY_PAGE_APARTMENT_TYPE: 'Your apartment type:',
  SUMMARY_PAGE_APARTMENT_NUMBER: 'Your apartment number:',
  PRICE_DISPLAY_CAPTION_LABEL: 'Total options',
  FINISH_PAGE_TITLE: `Thanks\u000A{name}`,
  FINISH_PAGE_END_BUTTON: 'Log out',
  PRIVATE_ROUTE_NOT_LOGGED_IN: 'Not logged in, <link>go to</link> login page.',
  USE_FORMAT_PRICE_LABEL: 'According to offer',
  USE_FORMAT_TOTAL_PRICE_LABEL: 'Offered price not included',
  ERROR_PAGE_HEADER: 'Sorry, an unhandled error occurred',
  ERROR_PAGE_INFO: 'Please reload the page, or try log out and log back in again.',
  ERROR_PAGE_RESET_BUTTON: 'Reload page',
  ERROR_PAGE_LOGOUT_BUTTON: 'Logout',
}
